import { useEffect, useRef } from "react"
import type { UseQueryExecute } from "urql"

export function useRefetchOnFocus(...executors: UseQueryExecute[]) {
  const executorsRef = useRef(executors)
  useEffect(() => {
    executorsRef.current = executors
  })

  useEffect(() => {
    const onVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        for (const execute of executorsRef.current) {
          execute({ requestPolicy: "network-only" })
        }
      }
    }

    document.addEventListener("visibilitychange", onVisibilityChange)
    return () => document.removeEventListener("visibilitychange", onVisibilityChange)
  }, [])
}
